import { Page, Spinner } from '@/components';

export function RouteFallback() {
  return (
    <Page width="medium">
      <Spinner size={32} label="Loading" />
    </Page>
  );
}
